import { Phone, Mail, Facebook, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/sd-logo-transparent.webp";

export const Footer = () => {
  return (
    <footer className="bg-primary text-white">
      <div className="container-narrow py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src={logo}
              alt="S&D Facility Service"
              loading="lazy"
              className="h-24 w-auto"
            />
            <p
              className="mt-5 max-w-xs text-sm leading-relaxed"
              style={{ color: "rgba(255,255,255,0.6)" }}
            >
              Ihr verlässlicher Partner für Reinigung und Gartenpflege im
              Murtal — professionell, pünktlich und persönlich.
            </p>
          </div>

          {/* Nav */}
          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white/90">
              Navigation
            </h4>
            <ul className="space-y-3 text-[15px]">
              {[
                { label: "Startseite", to: "/" },
                { label: "Über uns", to: "/ueber-uns" },
                { label: "Leistungen", to: "/leistungen" },
                { label: "Referenzen", to: "/referenzen" },
                { label: "Kontakt", to: "/kontakt" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-white/85 transition-colors hover:text-accent"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Rechtliches */}
          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white/90">
              Rechtliches
            </h4>
            <ul className="space-y-3 text-[15px]">
              <li>
                <Link to="/impressum" className="text-white/85 transition-colors hover:text-accent">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="text-white/85 transition-colors hover:text-accent">
                  Datenschutz
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white/90">
              Kontakt
            </h4>
            <ul className="space-y-3 text-[15px]">
              <li>
                <a
                  href="tel:+436603403710"
                  className="flex items-center gap-3 text-white/85 transition-colors hover:text-accent"
                >
                  <Phone className="h-4 w-4 text-accent" />
                  +43 660 340 3710
                </a>
              </li>
              <li>
                <a
                  href="mailto:surudaniel214@gmail.com"
                  className="flex items-center gap-3 text-white/85 transition-colors hover:text-accent"
                >
                  <Mail className="h-4 w-4 text-accent" />
                  surudaniel214@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/85">
                <MapPin className="mt-1 h-4 w-4 shrink-0 text-accent" />
                <span>Hauptstraße 4a<br />8753 Fohnsdorf/Sillweg<br />Österreich</span>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/share/1CUGKfkHip/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/85 transition-colors hover:text-accent"
                >
                  <Facebook className="h-4 w-4 text-accent" />
                  Facebook
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div
          className="mt-12 flex flex-col items-center justify-center gap-4 border-t pt-6"
          style={{ borderColor: "rgba(255,255,255,0.12)" }}
        >
          <p style={{ color: "rgba(255,255,255,0.5)", fontSize: 13 }} className="text-center">
            © 2025 S&amp;D Facility Service. Alle Rechte vorbehalten.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <button
              type="button"
              onClick={() => window.dispatchEvent(new CustomEvent("sd:open-cookie-notice"))}
              className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/5 px-5 py-2 text-xs font-medium text-white/80 transition-all hover:-translate-y-0.5 hover:border-white/50 hover:bg-white/10 hover:text-white"
            >
              Cookie-Einstellungen
            </button>
            <Link
              to="/admin/login"
              className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-5 py-2 text-xs font-medium text-white/80 transition-all hover:-translate-y-0.5 hover:border-accent hover:bg-accent/15 hover:text-accent"
            >
              Admin-Bereich
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
